module.exports = __webpack_public_path__ + "img/empty-plans.e86fdd8d.svg";